import { render } from "./FlyoutMenu.vue?vue&type=template&id=6af38c16&scoped=true"
import script from "./FlyoutMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./FlyoutMenu.vue?vue&type=script&setup=true&lang=js"

import "./FlyoutMenu.vue?vue&type=style&index=0&id=6af38c16&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af38c16"],['__file',"src/components/Ui/FlyoutMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6af38c16"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6af38c16', __exports__)) {
    api.reload('6af38c16', __exports__)
  }
  
  module.hot.accept("./FlyoutMenu.vue?vue&type=template&id=6af38c16&scoped=true", () => {
    api.rerender('6af38c16', render)
  })

}


export default __exports__